<div class="title title--big">Уведомления</div>
<app-loader *ngIf="unionLoading"></app-loader>
<div *ngIf="notificationsData" class="pos-r">
  <app-loader *ngIf="partialLoading"></app-loader>
  <div class="mt-32">
    <app-notifications-list-filter [filter]="filter"></app-notifications-list-filter>
  </div>

  <div class="mt-32">
    <app-notifications-table [notifications]="notificationsData" [filter]="filter"></app-notifications-table>
  </div>
</div>
